import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, Observable, Subject, throwError } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { SSO_SP_CONFIG } from '../config/auth.config';
import * as Msal from 'msal';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { environment } from 'src/environments/environment.dev';
// import * as jwt from 'jsonwebtoken';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  private readonly msalConfig = {
    auth: {
      clientId: SSO_SP_CONFIG.clientId,
      authority: `https://login.microsoftonline.com/${SSO_SP_CONFIG.tenantId}`,
      validateAuthority: true,
    },
  };

  private storageSub = new Subject<{ key: string; value: any }>();
  private readonly msalInstance: Msal.UserAgentApplication;
  public roleList: any;

  constructor(
    private http: HttpClient,
    private appService: AppService,
    private _snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private ngZone: NgZone
  ) {
    this.msalInstance = new Msal.UserAgentApplication(this.msalConfig);
    this.route.queryParams.subscribe((params) => {
      const code = params['code'];
      if (code) {
        this.exchangeCodeForToken(code);
      }
      window.addEventListener('storage', this.storageEventListener.bind(this));
    });
    this.oUpdateWIthUM();
    // (() => {
    //   const originalSetItem = sessionStorage.setItem;
    //   sessionStorage.setItem = function(key, value) {
    //     if ((key === "user-data" || key === 'authToken')&&(this['router'].url !== '/login'||this['router'].url !== '/auth' || this['router'].url !== '/' || this['router'].url !== '/home')) {
    //       alert("You cannot modify session data.");

    //       // Invalidate session or log out the user
    //       sessionStorage.clear(); // Or redirect to the login page, etc.
    //       window.location.href = "/login"; // Redirect to login or appropriate page
    //       return;
    //     }

    //     return originalSetItem.apply(this, arguments as unknown as [string, string]);
    //   };
    // })();
  }

  private storageEventListener(event: StorageEvent) {
    if (event.storageArea === sessionStorage) {
      this.ngZone.run(() => {
        this.storageSub.next({ key: event.key!, value: event.newValue });
      });
    }
  }

  watchStorage(): Subject<{ key: string; value: any }> {
    return this.storageSub;
  }

  oUpdateWIthUM() {
    let authToken = environment.AUTHTOKEN_FOR_UM_PORTAL; //CryptoJS.AES.encrypt("RMT-UM-user-profile-udpates",'authorization').toString()
    // console.log("authToken",authToken);

    fetch(this.appService.envVariable + '/api/user/um/authentication', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
      },
      body: JSON.stringify({}),
    })
      .then((res) => res.json())
      .then((res) => {})
      .catch(() => {
        console.log('Please check with data');
      });

    // this.authWIthUMPOrtal(body).subscribe((res:any) =>{

    //   if(res.length>0){
    //     console.log("res...",res);

    // let body:any = [];
    // res.access.forEach((item:any) => {
    //   let roleItem = this.roleList.find((r:any) => r.RoleID === ''+item.valueName);
    //   let obj ={
    //     'UserID':item.action ==="create" ? null: this.appService.userData.UserID,
    //     'RoleID':roleItem.RoleID,
    //     'UserType':roleItem.RoleName,
    //     'FirstName':res.lastName,
    //     'LastName':res.lastName,
    //     'Email':res.email,
    //     'IsActive':item.action === "delete" ? 0:1
    //   }
    //   body.push(obj)
    // });
    // this.toSetUserDetails(body)
    // }

    // });
  }

  toSetUserDetails(body: any) {
    this.appService.isLoading = true;
    this.setUserDetails(body).subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.openSnackBar('Successfully Inserted');
      }
    });
  }

  getRoleListData() {
    this.appService.isLoading = true;
    this.getRoleList().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.roleList = res;
      }
    });
  }

  exchangeCodeForToken(code: string) {
    const tokenUrl = `https://login.microsoftonline.com/${environment.APP_REG_TENANT_ID}/oauth2/v2.0/token`;
    const body = new HttpParams()
      .set('client_id', environment.APP_REG_CLIENT_ID)
      .set('grant_type', 'authorization_code')
      .set('code', code)
      .set('redirect_uri', environment.APP_REG_REDIRECT_URL)
      .set('scope', environment.APP_REG_SCOPE);

    this.http.post(tokenUrl, body).subscribe((response) => {
      // Handle token response
    });
  }

  catchError(error: any): Observable<Response> {
    this.appService.isLoading = false;
    this.appService.raIsLoading = false;
    if (error && error.error) {
      this.openSnackBar(error.error);
    }
    return throwError(error);
  }

  openSnackBar(message: any) {
    this._snackBar.dismiss();
    this._snackBar.open(message, 'X', {
      duration: 2000,
    });
  }

  closeSnackBar() {
    this._snackBar.dismiss();
  }

  loginWithPassword(userName: string, password: string): Promise<any> {
    const loginRequest = {
      scopes: ['user.read', 'openid', 'profile'],
      username: userName,
      password: password,
      redirectUri: SSO_SP_CONFIG.redirectURL,
    };

    return this.msalInstance
      .loginPopup(loginRequest)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  }

  //---------------- user data ---------------

  getCSRFToken() {
    return this.http.get('/csrf-token');
  }

  getUserDetails(mail: string): Observable<any> {
    return this.http.get(`/api/user/${mail}/get-user-data`);
    // .pipe(catchError((err) => this.catchError(err)))
  }

  getRoleList(): Observable<any> {
    return this.http
      .get(`/api/user/get-role-list`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setUserDetails(data: any): Observable<any> {
    return this.http
      .post(`/api/user/update-user-data`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  // -------------------- contact ------------

  getContactDetails(id: string = 'all'): Observable<any> {
    return this.http
      .get(`/api/contact/${id}/get-contact-list`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setContactDetails(data: any): Observable<any> {
    return this.http
      .post(`/api/contact/add-edit-contact-item`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  // -------------------- Rate Agreement ------------

  getAgreementDetails(
    id: string = 'all',
    mail: string = 'all'
  ): Observable<any> {
    return this.http
      .get(`/api/rate-management/${id}/${mail}/get-agreement-list`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  getRateTable(id: any): Observable<any> {
    return this.http
      .get(`/api/rate-management/${id}/get-rate-table`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setAgreementDetails(data: any): Observable<any> {
    return this.http
      .post(
        `/api/rate-management/update-rate-information`,
        JSON.stringify(data)
      )
      .pipe(catchError((err) => this.catchError(err)));
  }

  onApprove(id: any, usrid: any): Observable<any> {
    return this.http
      .get(`/api/rate-management/${id}/${usrid}/approval`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  // ---------------Rate table----------
  getRateTableList(id: number): Observable<any> {
    return this.http
      .get(`/api/rate-management/${id}/get-rate-table-list`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  getLTLTable(id: number): Observable<any> {
    return this.http
      .get(`/api/rate-management/${id}/get-ltl-table`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  getFTLTable(id: number): Observable<any> {
    return this.http
      .get(`/api/rate-management/${id}/get-ftl-table`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setFTLTable(data: any): Observable<any> {
    return this.http
      .post(`/api/rate-management/update-ftl-table`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  getFixedFTLTable(id: number): Observable<any> {
    return this.http
      .get(`/api/rate-management/${id}/get-fixed-ftl-table`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setFixedFTLTable(data: any): Observable<any> {
    return this.http
      .post(`/api/rate-management/update-fixed-ftl-table`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  setLTLTable(data: any): Observable<any> {
    return this.http
      .post(`/api/rate-management/update-ltl-table`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  setRateTable(data: any): Observable<any> {
    return this.http
      .post(`/api/rate-management/update-rate-table`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  setAdditionalCost(data: any): Observable<any> {
    return this.http
      .post(`/api/rate-management/update-addional-cost`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  setMautCost(data: any): Observable<any> {
    return this.http
      .post(`/api/rate-management/update-maut-cost`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  // -----------------um portal--------------

  authWIthUMPOrtal(body: any): Observable<any> {
    return this.http
      .post(`/api/user/um/authentication`, JSON.stringify(body))
      .pipe(catchError((err) => this.catchError(err)));
  }

  // ------------common--------------
  getListOfData(id: string): Observable<any> {
    return this.http
      .get(`/api/common/${id}/get-type-data`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  getRatioForChart(id: number): Observable<any> {
    return this.http
      .get(`/api/common/${id}/get-ratio-for-chart`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  getCountryList(): Observable<any> {
    return this.http
      .get(`/api/common/get-country-list`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  getColumnList(userId: number, id: string = 'all'): Observable<any> {
    return this.http.get(`/api/common/${userId}/${id}/get-column-setting`);
    // .pipe(catchError((err) => this.catchError(err)))
  }

  updatecolumnList(data: any): Observable<any> {
    return this.http
      .post(`/api/common/update-column-setting`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  // ---------file upload ---------
  getFileUpload(location: string, id: any): Observable<any> {
    return this.http.get(`/api/file-upload/${location}/${id}/file-upload`);
    // .pipe(catchError((err) => this.catchError(err)))
  }

  renameFileFolders(place: any, prevId: any, id: any): Observable<any> {
    return this.http.get(
      `/api/file-upload/${place}/${prevId}/${id}/rate-agreement-rename`
    );
    // .pipe(catchError((err) => this.catchError(err)))
  }

  onApprovalRename(place: any, prevId: any, id: any): Observable<any> {
    return this.http.get(
      `/api/file-upload/${place}/${prevId}/${id}/approval-rename`
    );
    // .pipe(catchError((err) => this.catchError(err)))
  }

  onDownlaodFiles(place: any, id: any): Observable<any> {
    return this.http.get(
      `/api/file-upload/${place}/${id}/onrateAgreemnt-download`
    );
    // .pipe(catchError((err) => this.catchError(err)))
  }

  onClearFolder(place: any): Observable<any> {
    return this.http.get(`/api/file-upload/${place}/on-clear-folder`);
    // .pipe(catchError((err) => this.catchError(err)))
  }

  onCopyFileFolders(place: any, prevId: any, id: any): Observable<any> {
    return this.http.get(
      `/api/file-upload/${place}/${prevId}/${id}/copy-new-files`
    );
    // .pipe(catchError((err) => this.catchError(err)))
  }

  onRenameFiles(id: any): Observable<any> {
    return this.http.get(`/api/file-upload/${id}/rate-file-rename`);
    // .pipe(catchError((err) => this.catchError(err)))
  }

  onReOrderFiles(agreementId: any, id: any): Observable<any> {
    return this.http.get(
      `/api/file-upload/${agreementId}/${id}/rate-file-reorder`
    );
    // .pipe(catchError((err) => this.catchError(err)))
  }

  onClearIntialFile(): Observable<any> {
    return this.http.get(`/api/file-upload/rate-file-remove`);
    // .pipe(catchError((err) => this.catchError(err)))
  }

  postFileToBlob(category: any, id: number, body: any): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    return this.http
      .post(`/api/file-upload/${category}/${id}/agreement-file-upload`, body, {
        headers,
      })
      .pipe(catchError((err) => this.catchError(err)));
  }

  postRateFileToBlob(
    category: any,
    id: number,
    orderId: number,
    body: any
  ): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    return this.http
      .post(
        `/api/file-upload/${category}/${id}/${orderId}/rate-file-upload`,
        body,
        { headers }
      )
      .pipe(catchError((err) => this.catchError(err)));
  }

  getFileFromBlob(category: any, id: number): Observable<any> {
    return this.http
      .get(`/api/file-upload/${category}/${id}/agreement-file-download`, {
        responseType: 'blob',
      })
      .pipe(catchError((err) => this.catchError(err)));
  }

  getRateFileFromBlob(category: any, id: number, orderId: number): any {
    return this.http.get(
      `/api/file-upload/${category}/${id}/${orderId}/rate-file-download`,
      { responseType: 'blob' }
    );
    // .pipe(catchError((err) => this.catchError(err)))
  }

  getDownlaodFile(): Observable<any> {
    return this.http
      .get(`/api/file-upload/file-download`)
      .pipe(catchError((err) => this.catchError(err)));
  }
  getAttachFileDeleted(id: any, name: string): Observable<any> {
    return this.http
      .get(`/api/file-upload/${id}/${name}/attach-file-delete`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  getApprovalValidation(id: any): Observable<any> {
    return this.http
      .get(`/api/rate-management/${id}/approval-validation`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  // -------------------- carrier ------------

  getCarrierDetails(id: string = 'all'): Observable<any> {
    return this.http
      .get(`/api/carrier/${id}/get-carrier-list`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setCarrierDetails(data: any): Observable<any> {
    return this.http
      .post(`/api/carrier/add-edit-carrier-item`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  //-------------bidpack ----------
  getBidpackDetails(id: string = 'all'): Observable<any> {
    return this.http
      .get(`/api/bidpack/${id}/get-bidpack-list`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setBidpackDetails(data: any): Observable<any> {
    return this.http
      .post(`/api/bidpack/add-edit-bidpack-item`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  getBidpackCountry(id: number): Observable<any> {
    return this.http
      .get(`/api/bidpack/${id}/get-bidpack-country`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setBidpackCountry(data: any): Observable<any> {
    return this.http
      .post(`/api/bidpack/add-edit-bidpack-country`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  // ----------fuel -escalator ---------
  getEscalatorDetails(id: string = 'all'): Observable<any> {
    return this.http
      .get(`/api/fuel-escalator/${id}/get-escalator-list`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setEscalatorDetails(data: any): Observable<any> {
    return this.http
      .post(`/api/fuel-escalator/add-escalator-item`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  getPriceCountry(id: number): Observable<any> {
    return this.http
      .get(`/api/fuel-escalator/${id}/get-escalator-country`)
      .pipe(catchError((err) => this.catchError(err)));
  }

  setPriceCountry(data: any): Observable<any> {
    return this.http
      .post(`/api/fuel-escalator/add-escalator-country`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  toCalculateFuelPrice(data: any): Observable<any> {
    return this.http
      .post(`/api/fuel-escalator/calculate-fuel-price`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }

  // ------------------delete ---------
  deleteItem(data: any): Observable<any> {
    return this.http
      .post(`/api/common/item-delete`, JSON.stringify(data))
      .pipe(catchError((err) => this.catchError(err)));
  }
}
